import { render, staticRenderFns } from "./OptionForm.vue?vue&type=template&id=3498dd7f&scoped=true&"
import script from "./OptionForm.vue?vue&type=script&lang=js&"
export * from "./OptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498dd7f",
  null
  
)

export default component.exports